import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import lottery from "vue-lottery";

import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

Vue.use(lottery);
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
